const carousels = [
  {
    title: '庆余年3：权谋风云再起',
    desc: '范闲重返京都，朝堂与江湖的双重博弈即将上演全新篇章，实力派演员阵容全员回归。',
    tag: '国产古装',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20atmosphere%20with%20warm%20golden%20lighting%2C%20traditional%20costume%20characters%20in%20imperial%20court%20setting%2C%20cinematic%20composition%20with%20soft%20shadows%2C%20elegant%20classical%20Chinese%20aesthetic%2C%20film%20grain%20texture%2C%20dramatic%20mood%20lighting%2C%20historical%20drama%20visual%20style&width=600&height=400&seq=carousel-qyn-01&orientation=landscape',
  },
  {
    title: '狂飙：年度现象级涉案剧',
    desc: '张译张颂文同台飙戏，二十年扫黑风云，人性与正义的终极较量。',
    tag: '国产涉案',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20visual%20style%2C%20urban%20night%20scene%20with%20neon%20lights%2C%20two%20men%20in%20tense%20confrontation%20silhouette%2C%20rainy%20street%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20dramatic%20shadows%2C%20suspenseful%20mood%2C%20police%20and%20underworld%20theme&width=600&height=400&seq=carousel-kb-02&orientation=landscape',
  },
  {
    title: '眼泪女王：年度甜虐韩剧',
    desc: '金秀贤金智媛演绎财阀夫妻的爱恨纠葛，甜蜜与虐心交织，每一帧都是心动瞬间。',
    tag: '韩剧爱情',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20aesthetic%20with%20soft%20pastel%20tones%2C%20cherry%20blossom%20and%20spring%20atmosphere%2C%20elegant%20couple%20silhouette%20in%20luxurious%20setting%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20and%20dreamy%20visual%20style%2C%20Korean%20melodrama%20cinematic%20look&width=600&height=400&seq=carousel-ylnw-03&orientation=landscape',
  },
  {
    title: '三体：国产科幻里程碑',
    desc: '刘慈欣原著改编，人类文明的存亡危机，宇宙社会学的宏大叙事震撼呈现。',
    tag: '国产科幻',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20visual%20with%20deep%20space%20and%20stars%2C%20mysterious%20three-body%20celestial%20phenomenon%2C%20cosmic%20scale%20drama%2C%20dark%20blue%20and%20purple%20space%20atmosphere%2C%20scientific%20and%20philosophical%20aesthetic%2C%20grand%20universe%20visual%20with%20light%20particles&width=600&height=400&seq=carousel-st-04&orientation=landscape',
  },
  {
    title: '玫瑰的故事：女性成长史诗',
    desc: '刘亦菲领衔主演，跨越二十年的女性成长故事，都市情感中找寻自我价值。',
    tag: '国产都市',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20Chinese%20urban%20drama%20aesthetic%2C%20rose%20flower%20symbolism%2C%20sophisticated%20city%20woman%20in%20fashionable%20setting%2C%20warm%20sunlight%20through%20windows%2C%20emotional%20growth%20narrative%20feel%2C%20soft%20romantic%20atmosphere%2C%20feminine%20and%20empowered%20visual%20style&width=600&height=400&seq=carousel-mg-05&orientation=landscape',
  },
  {
    title: '黑暗荣耀：复仇悬疑力作',
    desc: '宋慧乔颠覆形象演绎复仇大戏，校园暴力受害者的精密复仇计划，全程高能。',
    tag: '韩剧悬疑',
    img: 'https://readdy.ai/api/search-image?query=Dark%20sophisticated%20Korean%20thriller%20visual%2C%20contrast%20of%20luxury%20and%20darkness%2C%20elegant%20woman%20silhouette%20in%20shadow%2C%20moody%20atmospheric%20lighting%2C%20revenge%20theme%20with%20cold%20elegance%2C%20suspenseful%20cinematic%20composition%2C%20high%20contrast%20light%20and%20shadow&width=600&height=400&seq=carousel-hary-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          重磅推荐
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8">编辑精选，不可错过的口碑好剧</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carousels.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-medium bg-background-50/90 text-foreground-900 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}